// extracted by mini-css-extract-plugin
export default {"savedReportsTitle":"SavedProjects_savedReportsTitle__Z4tbF","savedProjectWrapper":"SavedProjects_savedProjectWrapper__O2IW8","pagination":"SavedProjects_pagination__nSQrz"};